import IFramePage from '@/components/common/IFramePage';
import { useGetMenuHeaderQuery } from '@/features/api/endpoints/LayoutEndpoints';
import type { IFrameLinkParams } from '@/models/common.type';
import { useDocumentTitle } from '@mantine/hooks';
import { useTranslate } from '@tolgee/react';

const StatisticsRequestPage = () => {
  const { t } = useTranslate();
  const { data } = useGetMenuHeaderQuery();

  useDocumentTitle(t('header.ask_for_stats'));

  if (data?.askForStatsType === 'iframe') {
    const params = data.askForStatsParams as unknown as IFrameLinkParams;

    return (
      <IFramePage
        type="iframe"
        link={data.askForStatsLink ?? ''}
        params={{
          ...params,
          title: t('header.ask_for_stats'),
        }}
      />
    );
  }

  return null;
};

export default StatisticsRequestPage;
